// NotificationProvider.tsx
import React, { useCallback, useMemo } from "react";
import { notification } from "antd";
import { NotificationContext } from "./NotificationContext";

export type NotifyProps = {
  type?: "warning" | "success" | "error" | "info";
  message: string;
  description?: string;
  duration?: number;
};

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [api, contextHolder] = notification.useNotification();

  const notify = useCallback(
    ({
      type = "info",
      message,
      description = "",
      duration = 4.5,
    }: NotifyProps) => {
      api[type]({
        message,
        description,
        duration,
      });
    },
    [api],
  );

  const value = useMemo(() => ({ notify }), [notify]);

  return (
    <NotificationContext.Provider value={value}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};
